import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import utils from "./utils/utils";
import VueI18n from 'vue-i18n'
import { SET_LANG } from '@/store/mutation-types'

import '@/assets/css/bootstrap.min.css'
import '@/assets/js/bootstrap.min.js'
import loading from '@/components/infrastructure/loading'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import echartsGL from 'echarts-gl';
import eleLocale from 'element-ui/lib/locale';
import enlocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
Vue.prototype.$echartsGL = echartsGL
// import moment from 'moment';
Vue.config.productionTip = false
Vue.prototype.apiUrl = process.env.VUE_APP_API_URL;
Vue.prototype.imgUrl = process.env.VUE_APP_API_URL_IMGURL;
// Vue.use(ElementUI, { enlocale });
// if (store.state.lang == 'zh-cn' || store.state.lang == 'zh-tw') {
//   Vue.use(ElementUI, { zhLocale })
//   console.log(store.state.lang)
//   // //localStorage.setItem('locale', 'zh')
// } else if (store.state.lang == 'en') {
//   console.log('en')
//   Vue.use(ElementUI, { enlocale })
// }
Vue.use(ElementUI);
Vue.use(loading);
Vue.use(VueI18n)
// Vue.filter('dateformat', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {

//   return moment(dataStr).format(pattern)

//   });
// console.log("9999")


// 创建实例 - 根据本地语言加载多语言文件
const i18n = new VueI18n({
  locale: () => store.state.lang, // 默认语言 可以借助cookie来设置和获取本地语言环境 从而加载不同的语言文件
  messages: {
    'zh-cn': require('./assets/lang/zh-cn'),
    'zh-tw': require('./assets/lang/zh-tw'),
    'en': require('./assets/lang/en'),
  }
})
//组件多语言
const i19n = new VueI18n({
  locale: store.state.lang || 'en',
  messages: {
    'zh-cn': zhLocale,
    'zh-tw': twLocale,
    'en': enlocale,
  }
})
eleLocale.i18n((key, value) => i19n.t(key, value));
// ElementLocale.i18n((key, value) => i18n.t(key, value));
Vue.prototype.i18n = i18n;
Vue.prototype.$store = store;
Vue.prototype.$utils = utils;
//订阅事件
store.subscribe((mutation, state) => {
  if (mutation.type === SET_LANG) {
    i18n.locale = mutation.payload;
  }
});
//定义全局函数
Vue.prototype.changeLanguage = (lang) => {
  store.commit(SET_LANG, lang)
};




// router.beforeEach((to, from, next) => {


// })


new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
